import type { UserType } from "@whatslly/types/User";
import { canUserLoginToTwilioSms, canUserLoginToWaba } from "@whatslly/commons/userMobileUtils";
import type { BaseUser } from "@whatslly/server-commons/baseUser";

export const canUserLoginToUseWhatsAppWeb = (userData: UserType | BaseUser | undefined) => {
  return !userData?.hide_whatsapp_channel && Boolean(userData?.channels?.["whatsapp-web"]?.enabled);
};

export const canUserLoginToUseTelegram = (userData: UserType | BaseUser | undefined) => {
  return !userData?.hide_telegram_channel && Boolean(userData?.channels?.["telegram"]?.enabled);
};

export const canUserLoginToUseImessage = (userData: UserType | BaseUser | undefined) => {
  return !userData?.allow_imessage && Boolean(userData?.channels?.["imessage"]?.enabled);
};

export const canUserLoginToDesktop = (userData: UserType | BaseUser | undefined) => {
  return (
    canUserLoginToUseWhatsAppWeb(userData) ||
    canUserLoginToUseTelegram(userData) ||
    canUserLoginToUseImessage(userData) ||
    canUserLoginToTwilioSms(userData) ||
    canUserLoginToWaba(userData)
  );
};
